<template>
  <div class="app-container pull-auto">
    <!-- 顶部按钮 -->
    <div class="invoice-top">
      <div class="top-border">
        <p>注意事项:</p>
        <p>开票金额为实际结算金额(含税)。</p>
        <p>单张发票最大额度为十万(不含税)，每超出十万，超出部分将开具在下一张发票中。</p>
      </div>
    </div>
    <el-form :inline="true" class="demo-form-inline">
      <el-row class="rowStyle borderBottomStyle">
        <el-col :span="24">
          <el-form-item label="项目信息">
            <el-input placeholder="请输入工程名称或工程地址" v-model="form.condition" clearable></el-input>
          </el-form-item>
          <el-form-item label="开工时间" class="searchdata">
            <el-date-picker v-model="form.time" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
              style="width:160px;"   @change="changedate">
            </el-date-picker>
          </el-form-item>
          <el-button @click.native="searchList" size="medium" icon="el-icon-search" type="primary">搜索</el-button>
        </el-col>
      </el-row>
      <el-row class="rowStyle">
        <el-col :span="24">
          <avue-crud :data="tableData" :option="billTableOption" :page="page" @size-change="sizeChange"
            @current-change="currentChange" ref="arrCrud"
            @search-reset="searchReset" @row-click="showRow" @select="showRow" class="avue-table-self">
            <template slot-scope="scope" slot="menuLeft" class="top-btn">
              <el-button @click="userSee" :disabled="selectedArr.length!=1" size="mini" icon="el-icon-view" type="primary">查看详情</el-button>
              <el-button @click="showTicketreq" :disabled="checkDetail" size="mini" icon="el-icon-document-checked" type="primary">申请开票</el-button>
              <el-button @click="exportExcel" size="mini" icon="el-icon-receiving" type="primary">导出</el-button>
            </template>
          </avue-crud>
        </el-col>
      </el-row>
    </el-form>

    <!-- 申请开票 -->
    <el-dialog title="申请开票" :visible.sync="requestTicketShow" class="requestTicketShow">
      <el-form>
        <div>您选取了<span class="fz-20">{{ticketInfo.count}}</span>条单据开具发票(若选中多条订单, 订单金额将合并开具在一张票据中), 开票金额合计:
         <span class="fz-20">￥{{ticketInfo.sumPrice}}</span></div>
        <div class="top-border">
          <p>注意事项:开票金额为实际结算金额。</p>
          <p>自2017.07.01起，申请普通发票需填写税号信息，否则将无法应税使用，请及时维护您的税号信息。</p>
          <p>申请纸质增值税普通发票，如金额未满XXX元，快递费用到付需自行承担。</p>
        </div>
        <el-row>
          <el-col :span="5">发票抬头：</el-col>
          <el-col :span="19">{{companyInfo.name}}</el-col>
        </el-row>
        <el-row>
           <el-col :span="5">开具类型：</el-col>
           <el-col :span="19">企业</el-col>
        </el-row>
        <el-row>
           <el-col :span="5">发票类型：</el-col>
           <el-radio v-model="ticketType" label="2" :disabled="isAllInfo">增值税专用发票</el-radio>
           <el-radio v-model="ticketType" label="1">增值税普通发票</el-radio>
           <span class="el-tips" v-if="isAllInfo">您填写的信息不完整,不能开取增值税发票</span>
        </el-row>
        <el-row>
           <el-col :span="5">税务登记证号：</el-col>
           <el-col :span="19">{{companyInfo.taxNum}}</el-col>
        </el-row>
        <el-row v-if="ticketType==2">
          <el-row>
             <el-col :span="5">开户银行名称：</el-col>
             <el-col :span="19">{{openingBank}}</el-col>
          </el-row>
          <el-row>
             <el-col :span="5">注册场所地址：</el-col>
             <el-col :span="19">{{address}}</el-col>
          </el-row>
          <el-row>
             <el-col :span="5">基本开户账号：</el-col>
             <el-col :span="19">{{bankAccount}}</el-col>
          </el-row>
          <el-row>
             <el-col :span="5">注册固定电话：</el-col>
             <el-col :span="19">{{telephone}}</el-col>
          </el-row>
        </el-row>

        <el-row>
           <el-col :span="5">发票性质：</el-col>
           <el-col :span="19">纸质</el-col>
        </el-row>
        <el-row>
           <el-col :span="5">备注：</el-col>
           <el-col :span="19">
             <el-input
               type="textarea"
               :autosize="{ minRows: 2, maxRows: 4}"
               placeholder="该备注信息会展示在发票上，如果需要请录入，否则无需录入任何信息。"
               v-model="ticketTips">
             </el-input>
           </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
           <el-col :span="5">收件地址：</el-col>
           <el-col :span="14">
             <div>
               <span>{{defaultAddress.provinceName}} {{defaultAddress.cityName}} {{defaultAddress.areaName}} {{defaultAddress.addressee}} </span>
               <span> {{defaultAddress.zipCode}}</span>
             </div>
             <div>
               <span>{{defaultAddress.contacts}} </span>
               <span> {{defaultAddress.phone}}</span>
             </div>
           </el-col>
           <el-col :span="5">
             <el-button @click="editResAddress" size="mini" icon="el-icon-edit" round>修改地址</el-button>
           </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="requestTicketShow=false">取消</el-button>
        <el-button @click="comfirm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 发票地址管理 -->
    <el-dialog title="发票地址管理" :visible.sync="ticketListVisible">
      <avue-crud :data="ticketTableData" :option="ticketOption" @row-click="showinvoiceRow">
        <template slot-scope="scope" slot="id">
          <el-radio class="radio" v-model="invoiceRadio" :label="scope.row.id"></el-radio>
        </template>
      </avue-crud>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ticketListVisible=false">取消</el-button>
        <el-button @click="addressSelected">确定</el-button>
      </div>
    </el-dialog>

    <!--任务详情-->
    <orderinfo2 ref="child" @refresh="refresh"></orderinfo2>
  </div>
</template>

<script>
  import {
    fetchFinanceList,
    exportInvoiceRequest
  } from '@/api/admin/financeManagement'
  import {
    getAllInvoiceAddress,
    getCompanyInvoiceInfo,
    addInvoice
  } from '@/api/admin/invoiceManagement'
  import {
    billTableOption_request,
    ticketOption
  } from '@/const/asset/base/manufacturerinfo'
  import {
    objKeySort
  } from '@/util/ajaxsign'
  import {
    getDateStr
  } from "@/util/date";
  import orderinfo2 from '../../orderManager/orderinfo2.vue'
  import '../../../styles/table.css';
  export default {
    name: 'invoiceRequest',
    components: {
      orderinfo2
    },
    data() {
      return {
        activeName: 'frist',
        listQuery: {
          current: 1,
          size: 10,
          total: 0,
        },
        // 搜索
        form: {
          time: '',
          state: '',
          condition: '',
          invoiceState: ''
        },
        ticketListVisible: false, //发票管理 窗口
        invoiceRadio:'',
        ticketInfo:{
          id:'',
          count:0,
          sumPrice:0
        },
        ticketType:0,//发票类型 1 普通发票 2专用发票
        ticketTips:'',//备注
        requestTicketShow: false, //申请开票弹窗
        ticketTableData: [], //发票地址管理数据
        defaultAddress:{},//默认发票地址
        checkinvoiceDetail:false,
        radio: '',
        //按钮禁用开关
        checkDetail: true,
        add: false,
        tableData: [],
        page: {
          pageSizes: [10, 20, 50, 100],
          currentPage: 1,
          total: 0,
          pageSize: 10
        },
        tableLoading: false,
        billTableOption: billTableOption_request,
        ticketOption: ticketOption,
        userInfo: '',
        isAdmin: false,
        address:'',
        bankAccount:'',
        openingBank:'',
        telephone:'',
        companyInfo:{},
        isAllInfo:true,//是否信息全部都含有
        mdata: {}, //搜索条件
        arrCrud:[],//显示的选择的数据
        selectedRow:{},//选择行数据
        selectedArr:[],//已选的行数据
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    created() {
      this.getList();
      this.getcompany();
    },
    mounted: function() {},
    computed: {

    },
    methods: {
      //刷新列表操作
      refresh() {
        let that=this
        that.selectedArr=[];
        that.checkDetail=true;
        that.getList();
      },

      // 查看工程详情
      userSee() {
        let that=this
        this.$refs.child.setsataus(that.selectedArr[0].projectId, '', true);
      },

      showinvoiceRow(row) {
        this.invoiceRadio = row.id;
        this.handleinvoiceRowClick(row);
      },

      // 获取当前行数据
      handleinvoiceRowClick(row) {
        let that = this
        that.selectedRow = row;
        if (row) {
          that.checkinvoiceDetail = false
        } else {
          that.checkinvoiceDetail = true
        }
      },

      // 检查是否可点击按钮
      isDisable(arr){
        let that=this
        if(arr.length>0){
          that.checkDetail = false;
        }else{
          that.checkDetail = true;
        }
      },

      showRow(val) {
        let that=this
        if(Object.prototype.toString.call(val)== '[object Array]'){
          that.selectedArr = val;
          that.checkDetail = false;
        }else{

          // 有勾选的数据
          if(that.selectedArr.length>0){
            // 遍历并判断是否是选择了 已在选择数据中的数据
            that.selectedArr.slice().reverse().forEach((citem, index, object)=>{
              if(citem.projectId==val.projectId){
                // 取消已经勾选的
                that.selectedArr.splice(object.length - 1 - index, 1);
                that.isDisable(that.selectedArr)
                that.$nextTick(() => {
                    that.$refs.arrCrud.toggleRowSelection(val, false);
                });
              }
            })
          }
          if(that.tableData.length>0){
            that.tableData.forEach(item=>{
              if(item.projectId==val.projectId&&item.check==true){
                 item.check=false
                 that.isDisable(that.selectedArr)
                 that.$nextTick(() => {
                   that.$refs.arrCrud.toggleRowSelection(item, false);
                 })
              }else if((val.check==undefined||val.check==false)&&item.projectId==val.projectId){
                item.check=true
                that.selectedArr.push(item)
                that.checkDetail=false
                that.$nextTick(() => {
                  that.$refs.arrCrud.toggleRowSelection(item, true);
                })
              }
            })
          }
        }
      },
      // 提交搜索
      searchList() {
        let that = this
        that.getList();
      },
      //清空收缩条件
      searchReset() {
        this.form = {};
        this.listQuery.current = 1;
        this.listQuery.size = 10;
        this.getList();
      },

      getList() {
        let that = this
        that.tableLoading = true;
        that.radio = undefined;

        that.mdata.pageNum = that.listQuery.current;
        that.mdata.condition = that.form.condition;
        that.mdata.pageSize = that.page.pageSize;
        that.mdata.state=1;
        that.mdata.invoiceState=0;

        if (that.form.time) {
          that.mdata.startDate = that.form.time[0];
          that.mdata.stopDate = that.form.time[1];
        }else{
          for(let key in that.mdata){
            if(key=='startDate'){
              delete that.mdata[key];
            }
            if(key=='stopDate'){
              delete that.mdata[key];
            }
          }
        }
        fetchFinanceList(objKeySort(that.mdata)).then(response => {
          if (response.data.code == 200) {
            that.tableData = response.data.data.rows;
            that.tableData.forEach(item=>{
              item.check=false
            })
            that.page.total = response.data.data.total;
          }
          that.tableLoading = false
        })
      },

      sizeChange(val) {
        this.listQuery.size = val;
        this.page.pageSize = val;
        this.listQuery.current = 1;
        this.getList()
      },
      currentChange(val) {
        this.listQuery.current = val;
        this.page.currentPage = val;
        this.getList()
      },

      //获取个人信息
      getcompany() {
        let that = this
        that.userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"))
        if(that.userInfo.id!=1){
          let company = that.userInfo.company != null ? that.userInfo.company : undefined;
          if (company != undefined) {
            if (company.userId == that.userInfo.id) {
              that.isAdmin = true;
            }
          }
          that.companyInfo = company
        }else{
          that.companyInfo={
            name:'',
            taxNum:''
          }
        }
      },

      // 申请发票 弹窗
      showTicketreq() {
        let that = this;
        that.getCompanyInvoiceInfo();
        that.getAllInvoiceAddress();
        that.requestTicketShow = true;
        that.ticketInfo.sumPrice=0;
        that.ticketInfo.count==0;
        let _id='';
        that.selectedArr.forEach((item)=>{
          that.ticketInfo.sumPrice+=(item.priceSum?item.priceSum:item.price);
          _id+=item.projectId+',';
        })
        that.ticketInfo.id=_id.slice(0,_id.length-1);
        that.ticketInfo.count=that.selectedArr.length;
      },

      //确定 开取发票
      comfirm(){
        let that=this
        if(!that.ticketType>0){
          that.$message({
            message:'请选择发票类型',
            type:'warning'
          })
          return
        }
        let data={
          addressId:that.defaultAddress.id,
          money:that.ticketInfo.sumPrice,
          projectIds:that.ticketInfo.id,
          remarks:that.ticketTips,
          type:that.ticketType
        }
        addInvoice(objKeySort(data)).then(response=>{
          if(response.data.code==200){
            that.$notify({
              title: '温馨提示',
              message: '已提交申请,请耐心等待审批!',
              type: 'success'
            });
            that.requestTicketShow=false;
            that.selectedArr=[];
            that.getList();
          }
        })
      },
      //获取所有发票地址信息
      getAllInvoiceAddress(){
        let that =this
        getAllInvoiceAddress(objKeySort({})).then(response => {
          if(response.data.code==200){
            that.ticketTableData = response.data.data;
            response.data.data.forEach(item=>{
              if(item.isDefault==1){
                that.defaultAddress = item;
                that.invoiceRadio=item.id;
              }
            })
          }
        })
      },
      //获取企业开票信息
      getCompanyInvoiceInfo(){
        let that =this;
        getCompanyInvoiceInfo(objKeySort({})).then(response => {
          if(response.data.code==200){
            that.address=response.data.data.address?response.data.data.address:'';
            that.bankAccount=response.data.data.bankAccount?response.data.data.bankAccount:'';
            that.openingBank=response.data.data.openingBank?response.data.data.openingBank:'';
            that.telephone=response.data.data.telephone?response.data.data.telephone:'';
            if(!that.address||!that.bankAccount||!that.openingBank||!that.telephone){
              that.isAllInfo=true
            }
          }
        })
      },

      //清楚 搜索数据
      changedate(value) {
        let that=this;
        if (value == null) {
          that.form.time = []
        }
      },
      //选择收件地址
      addressSelected(){
        let that=this;
        that.ticketListVisible=false;
        if(that.selectedRow.id){
          that.defaultAddress=that.selectedRow;
        }
      },
      //修改收件地址 弹窗
      editResAddress() {
        let that = this
        that.invoiceRadio=that.defaultAddress.id;
        that.ticketListVisible=true;
      },
      //导出 Excel
      exportExcel() {
        let that=this
        that.tableLoading = true;
        that.radio = undefined;

        that.mdata.pageNum = that.listQuery.current;
        that.mdata.condition = that.form.condition;
        that.mdata.pageSize = that.page.pageSize;
        that.mdata.state=1;
        that.mdata.invoiceState=0;

        if (that.form.time) {
          that.mdata.startDate = that.form.time[0];
          that.mdata.stopDate = that.form.time[1];
        }else{
          for(let key in that.mdata){
            if(key=='startDate'){
              delete that.mdata[key];
            }
            if(key=='stopDate'){
              delete that.mdata[key];
            }
          }
        }

        exportInvoiceRequest(objKeySort(that.mdata)).then(res=>{
          if(res.status==200){
             let blob = new Blob([res.data], { type: "application/vnd.ms-excel" } )
             let fileName = '发票索取'+getDateStr(new Date().getTime(),0,1) + '.xlsx';
             if (window.navigator.msSaveOrOpenBlob) {
               navigator.msSaveBlob(blob, fileName);
             }else {
               let link = document.createElement('a')
               link.href = URL.createObjectURL(blob);
               link.download = fileName;
               document.body.appendChild(link);
               link.click()
             }
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .el-table {
    margin-top: 22px;
  }

  .el_s_left {
    float: left
  }

  .el_btn {
    clear: both;
  }

  .filter-item1 {
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0 !important;
    margin-left: 0 !important;
    margin-right: 22px;
  }

  .el-radio__label {
    display: none;
  }

  .sh_tip {
    vertical-align: top;
    display: inline-block
  }

  .lf_item span:first-child {
    display: inline-block;
    width: 100px;
    vertical-align: top;
  }

  .el-form-items {
    float: left;
    width: 48% !important;
  }

  .el-form-itemss {
    width: 300px !important;
    height: 40px !important;
    background-attachment: #fff !important;
  }

  .el-form-itemss .el-input {
    outline: none !important;
  }

  .el-f-item {
    width: 100% !important;
  }

  .el-dialog__header {
    margin-bottom: 0px;
  }

  .el-tag {
    border: 0 !important;
    color: #666 !important;
    background-color: transparent;
    font-size: 14px;
  }

  .dialog-footer {
    margin-left: 0 !important;
  }

  .filter-item1 {
    width: auto;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    border: 0 !important;
    margin-left: 0 !important;
    margin-right: 22px;
  }

  .is-required {}

  .el-dialog__footer {
    height: 120px;
  }

  .p1 {
    width: 100% !important;
  }

  .part {
    position: relative;
  }

  .el-table /deep/ .el-table__row:nth-child(even) {
    background-color: #F6F9FF !important;
  }

  .avue-crud /deep/ .avue-crud__left {
    display: flex;
  }

  .ticketmanage {

    .el-select,
    .el-row {
      margin-bottom: 14px;
    }

    .el-col-4 {
      text-align: center;
    }
  }

  .borderBottomStyle /deep/ .el-form-item {
    margin-bottom: 0;
  }

  .requestTicketShow {
    /deep/ .el-dialog__body {
      padding: 20px 40px 30px 40px !important;
    }

    /deep/ .el-col-5 {
      text-align: right;
    }
  }

  .ticketListVisible /deep/ .avue-crud__menu {
    display: none;
  }

  .pull-auto .avue-crud /deep/ .avue-crud__tip {
    display: none;
  }
  .el-tips{
    color: rgba(255,153,0,1);
    font-size: 12px;
  }
  .fz-20{
    color: rgba(255,153,0,1);
    font-size: 20px;
  }
</style>
